import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";
import ChannelTeamForm from "../channel-team-form";
import { useChannelTeamCtx } from "../context";
import { useToastContext } from "../../shared/ToastContext";
import { useMutation } from "@apollo/react-hooks";
import { CREATE_CHANNEL_TEAM } from "../../../graphql/mutations/channel-team";
import useTimeout from "../../../hooks/useTimeout";
import { handleError } from "../../../helper";

export default function ChannelTeamCreate({ open, onClose }) {
    const { refetch } = useChannelTeamCtx();
    const { toggleToast, setNotify } = useToastContext();

    const [setDelay] = useTimeout();
    const [createChannelTeam, { loading }] = useMutation(CREATE_CHANNEL_TEAM, {
        onCompleted: () => {
            setNotify({ msg: "Create Channel Team successfully", err: false });

            onClose();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const formRef = React.useRef(null);
    const handleSubmit = useCallback(() => {
        if (!formRef.current || !formRef.current.getState) return;
        const input = formRef.current.getState();
        if (!input) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        createChannelTeam({
            variables: {
                input,
            },
        });
    }, [createChannelTeam, toggleToast, setNotify]);

    return (
        <Modal
            title="Create Channel Team"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading,
            }}
        >
            <ChannelTeamForm ref={formRef} />
        </Modal>
    );
}
